"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";
import { useAuth } from "@/components/providers/auth-provider";

const CourseHubShell = dynamic(
  () => import("./course-hub-shell").then((m) => m.CourseHubShell),
  { ssr: false, loading: () => null },
);

/**
 * `SITE-CRS01`: the course hub (progress, the next lesson, live classes) is for
 * a signed-in learner who owns the course, and renders nothing for anyone else.
 * It was imported into every course page and hydrated for every visitor; now
 * its code loads only once a session exists, so a signed-out visitor never
 * downloads it. The hub still decides ownership itself.
 */
export function CourseHubShellGate(props: ComponentProps<typeof CourseHubShell>) {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return null;
  return <CourseHubShell {...props} />;
}
